import styled from 'styled-components'
import WifiSvg from '../../assets/icons/amenities-icons/wifi.svg'
import TvSvg from '../../assets/icons/amenities-icons/tv.svg'
import PetsSvg from '../../assets/icons/amenities-icons/pet.svg'
import DishwasherSvg from '../../assets/icons/amenities-icons/dish-washer.svg'
import WashingMachineSvg from '../../assets/icons/amenities-icons/washing-machine.svg'
import StairsSvg from '../../assets/icons/amenities-icons/stairs.svg'
import BedroomSvg from '../../assets/icons/amenities-icons/bedroom-icon.svg'
import ShowerSvg from '../../assets/icons/amenities-icons/shower-icon.svg'
import GuestSvg from '../../assets/icons/amenities-icons/guest-icon.svg'
import RoomAreaSvg from '../../assets/icons/amenities-icons/room-area.svg'
import SmokingSvg from '../../assets/icons/feature-icons/smoking.svg'
import AlertTriangleSvg from '../../assets/icons/alert-triangle.svg'
import CheckedCircleSvg from '../../assets/icons/checked-circle.svg'
import WarningTriangleSvg from '../../assets/icons/warning-triangle.svg'
import ElevatorSvg from '../../assets/icons/elevator.svg'
import GroundLevelSvg from '../../assets/icons/ground-level.svg'
import SaunaSvg from '../../assets/icons/sauna.svg'
import WheelChairSvg from '../../assets/icons/wheelchair.svg'
import PoolSvg from '../../assets/icons/pool.svg'
import ChargingStationSvg from '../../assets/icons/charging-station.svg'

const Styled = (Svg: React.FC<React.SVGProps<SVGSVGElement>>) => styled(Svg)``

const IconMapping: Record<string, ReturnType<typeof Styled>> = {
    wifi: Styled(WifiSvg),
    tv: Styled(TvSvg),
    television: Styled(TvSvg),
    smoking: Styled(SmokingSvg),
    pets: Styled(PetsSvg),
    dishwasher: Styled(DishwasherSvg),
    washingMachine: Styled(WashingMachineSvg),
    stairs: Styled(StairsSvg),
    groundLevel: Styled(GroundLevelSvg),
    elevator: Styled(ElevatorSvg),
    sauna: Styled(SaunaSvg),
    alertTriangle: Styled(AlertTriangleSvg),
    checkedCircle: Styled(CheckedCircleSvg),
    warningTriangle: Styled(WarningTriangleSvg),
    barrierFree: Styled(WheelChairSvg),
    wheelChairWithBarrier: Styled(WheelChairSvg),
    pool: Styled(PoolSvg),
    chargingStation: Styled(ChargingStationSvg),
    beds: Styled(BedroomSvg),
    bathrooms: Styled(ShowerSvg),
    guests: Styled(GuestSvg),
    area: Styled(RoomAreaSvg),
}

export default IconMapping
